import request from '@/utils/request'

// 获取商品详情（含SKU/图片，管理端编辑用）
export const getAdminGoodsDetailApi = (goodsId) => {
  return request.get('/goods/getadmin', {
    params: {
      goodsId
    },
    headers: { 'X-Admin': 1 }
  })
}


// ============ 商品管理 ============

// 获取全部商品（含已下架），支持按商品名称关键字搜索
// merchantId：超级管理员可按商家筛选（0/不传=全部）
export const getAdminGoodsListApi = (page, goodsName, merchantId = 0) => {
  return request.get('/goods/list', {
    params: {
      all: 1,
      page,
      goodsName,
      merchantId
    },
    headers: { 'X-Admin': 1 }
  })
}

// 新增商品
export const addGoodsApi = (data) => {
  return request.post('/goods/add', data, { headers: { 'X-Admin': 1 } })
}

// 修改商品
export const editGoodsApi = (data) => {
  return request.post('/goods/edit', data, { headers: { 'X-Admin': 1 } })
}

// 商品上架/下架
export const toggleGoodsStatusApi = (goodsId) => {
  return request.post('/goods/togglestatus', {
    goods_id: goodsId
  }, { headers: { 'X-Admin': 1 } })
}

// 商品是否在首页展示切换
export const toggleHomeGoodsApi = (goodsId) => {
  return request.post('/goods/togglehome', {
    goods_id: goodsId
  }, { headers: { 'X-Admin': 1 } })
}

// 删除商品
export const deleteGoodsApi = (goodsId) => {
  return request.post('/goods/delete', {
    goods_id: goodsId
  }, { headers: { 'X-Admin': 1 } })
}

// ============ 订单管理 ============

// 获取订单统计数据（全量，不分页）
export const getAdminOrderStatsApi = () => {
  return request.get('/order/stats', { headers: { 'X-Admin': 1 } })
}

// 获取全部订单（支持关键词搜索：订单号 / 买家手机号 / 买家昵称）
export const getAdminOrderListApi = (dataType, page, keyword = '') => {
  return request.get('/order/list', {
    params: {
      all: 1,
      dataType,
      page,
      keyword
    },
    headers: { 'X-Admin': 1 }
  })
}

// 订单发货（待发货 -> 待收货）
export const shipOrderApi = (orderId) => {
  return request.post('/order/ship', {
    order_id: orderId
  }, { headers: { 'X-Admin': 1 } })
}

// 取消订单
export const cancelOrderApi = (orderId) => {
  return request.post('/order/cancel', {
    order_id: orderId
  }, { headers: { 'X-Admin': 1 } })
}

// 批量发货
export const batchShipOrderApi = (orderIds) => {
  return request.post('/order/batchShip', {
    orderIds: orderIds
  }, { headers: { 'X-Admin': 1 } })
}

// ============ 新增：确认收货 ============
// 确认收货（待收货 -> 已完成）
export const confirmOrderApi = (orderId) => {
  return request.post('/order/confirm', {
    order_id: orderId
  }, { headers: { 'X-Admin': 1 } })
}

// 处理退款申请（approve=同意 reject=拒绝）
export const handleRefundApi = (refundId, action, reply = '') => {
  return request.post('/order/handleRefund', {
    refund_id: refundId,
    action,
    reply
  }, { headers: { 'X-Admin': 1 } })
}

// ============ 分类 ============

// 获取全部分类
export const getAdminCategoryApi = () => {
  return request.get('/category/list')
}

// ============ 数据分析 ============

// 获取统计数据概览（支持自定义日期范围，不传默认当天）
export const getStatsOverviewApi = (startDate, endDate) => {
  return request.get('/stat/overview', {
    params: {
      start_date: startDate,
      end_date: endDate
    },
    headers: { 'X-Admin': 1 }
  })
}

// 记录商品浏览（商品详情页调用，用于商品浏览量 / 访客数统计）
export const recordGoodsViewApi = (goodsId) => {
  return request.post('/stat/recordview', {
    goods_id: goodsId
  })
}

// ============ 图片空间 ============

// 上传图片到图片空间（formData：file）
export const uploadImageLibraryApi = (file) => {
  const formData = new FormData()
  formData.append('file', file)
  return request.post('/imagelibrary/upload', formData, {
    headers: { 'X-Admin': 1, 'Content-Type': 'multipart/form-data' }
  })
}

// 分页获取图片空间图片
export const getImageLibraryApi = (page, pageSize = 24) => {
  return request.get('/imagelibrary/list', {
    params: {
      page,
      pageSize
    },
    headers: { 'X-Admin': 1 }
  })
}

// 删除图片空间图片
export const deleteImageLibraryApi = (id) => {
  return request.post('/imagelibrary/delete', {
    id
  }, { headers: { 'X-Admin': 1 } })
}

// ============ 自动发货（虚拟卡密） ============

// 保存自动发货设置（按商品 + 规格）
// items: [{ sku_id, enabled, update_order_status, allow_repeat_card, usage_note }]
export const saveAutoDeliveryApi = (goodsId, items) => {
  return request.post('/goods/saveautodelivery', {
    goods_id: goodsId,
    items
  }, { headers: { 'X-Admin': 1 } })
}

// 批量添加卡密（cards 可为「每行一个卡密」的字符串或数组）
export const addGoodsCardsApi = (goodsId, skuId, cards) => {
  return request.post('/goods/addcards', {
    goods_id: goodsId,
    sku_id: skuId,
    cards
  }, { headers: { 'X-Admin': 1 } })
}

// 卡密列表（分页）
export const getGoodsCardsApi = (goodsId, skuId, page = 1, pageSize = 20) => {
  return request.get('/goods/cards', {
    params: { goods_id: goodsId, sku_id: skuId, page, pageSize },
    headers: { 'X-Admin': 1 }
  })
}

// 删除卡密
export const deleteGoodsCardApi = (id) => {
  return request.post('/goods/deletecard', { id }, { headers: { 'X-Admin': 1 } })
}

// ============ 系统设置 ============

// 获取系统设置（公开：商城支付页也调用）
export const getSettingsApi = () => {
  return request.get('/settings/get')
}

// 保存系统设置（仅管理员）
export const saveSettingsApi = (data) => {
  return request.post('/settings/save', data, { headers: { 'X-Admin': 1 } })
}


// ============ 百度收录（主动推送） ============

// 推送状态（站点 / 准入密钥 / URL 形式 / 上次推送结果与剩余配额）
export const getBaiduPushStatusApi = () => {
  return request.get('/baidu/status', { headers: { 'X-Admin': 1 } })
}

// 手动推送
// type: 'home'（首页）| 'goods'（单个商品，需 goods_id）| 'all'（全站）| 'custom'（自定义 urls）
export const baiduPushApi = (payload) => {
  return request.post('/baidu/push', payload, { headers: { 'X-Admin': 1 } })
}

// 最近推送日志
export const getBaiduPushLogApi = (limit = 30) => {
  return request.get('/baidu/log', {
    params: { limit },
    headers: { 'X-Admin': 1 }
  })
}


// ============ SEO 站点地图（sitemap.xml） ============

// sitemap 中的 URL 数量与示例（管理员，用于后台预览）
export const getSitemapUrlsApi = () => {
  return request.get('/sitemap/urls', { headers: { 'X-Admin': 1 } })
}


// ============ 管理后台登录 ============

// 获取管理员登录图形验证码
export const getAdminCaptchaApi = () => {
  return request.get('/admin/getcaptcha')
}

// 管理员登录
export const adminLoginApi = (username, password, captchaCode, captchaKey) => {
  return request.post('/admin/login', {
    username,
    password,
    captcha_code: captchaCode,
    captcha_key: captchaKey
  })
}

// 校验管理员登录状态
export const adminCheckAuthApi = () => {
  return request.get('/admin/check')
}

// 修改管理员密码
export const adminChangePasswordApi = (oldPassword, newPassword) => {
  return request.post('/admin/changepassword', {
    old_password: oldPassword,
    new_password: newPassword
  })
}

// 退出登录
export const adminLogoutApi = () => {
  return request.post('/admin/logout')
}